export default __webpack_public_path__ + "static/favicon-4d4441202907c8fcc86aeca04ed92278.ico";